import script from "./VirtualList.vue?vue&type=script&lang=ts&setup=true"
export * from "./VirtualList.vue?vue&type=script&lang=ts&setup=true"

import "./VirtualList.vue?vue&type=style&index=0&id=4dada442&scoped=true&lang=css"

import exportComponent from "/home/deployment/actions-runner/_work/pwscorecards-vue/pwscorecards-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dada442"]])

export default __exports__